import React from "react"; 
import CarrierEquipmentTypeListPageContainer from "./CarrierEquipmentTypeListPageContainer";

export class CarrierEquipmentTypePage extends React.Component {
  render() {
    return <CarrierEquipmentTypeListPageContainer {...this.props} />;
  }
}
